import { createReducer } from 'redux-act';
import * as a from '../actions/calendarReport';

const initialState = { data: [] };

export default createReducer({
    [a.setCalendarReports]: (state, data) => ({ ...state, data }),
}, initialState);
